import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TickList } from '../../Redux/action/tickList';
import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import RcRate from 'rc-rate';

import toast, { Toaster } from 'react-hot-toast';

import axiosInstance from '../../utils/axiosInstance';
import VideoIcon from "./img/video-icon.svg";
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import SwTable from '../Common/SwTable/SwTable';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwKpi from '../Common/SwKPI/SwKPI';
import SwKpiGroup from '../Common/SwKPI/SwKpiGroup';
import SwModal from '../Common/SwModal/SwModal';
import 'rc-rate/assets/index.css';
import SwTooltip from '../Common/SwTooltip/SwTooltip';
import AntDUpload from '../Common/AntDUpload/AntDUpload';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class TicktingTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCommentModal: false,
      isModalOpenFeedback: false,
      sendMessage: '',

      returnedMessage: '', // Store reason for return
      showCommentSection: false,
      commentMessage: '',
      commentFiles: [], // Stores S3 keys
      commentFileNames: [], // Stores original file names
      uploading: false,
      fileInputKey: Date.now(),

      returnFiles: [], // array of uploaded file URLs
      returnFileNames: [], // array of file names
      // Store selected file
      isSubmitting: false, // Submission loading state
      TicktingAllList: [],
      isModalOpen1: false,
      totleSeatData: '',
      closedSeatData: '',
      pendingSeatData: '',
      popupDetails: {},
      setIndex: 0,
      loader: false,
      ticketDetailsView: [],
      isModalOpen: false,
      rating: 0,
      feedback: '',
      isLoading: false,
      uploading: false,
      fileInputKey: Date.now(), // For resetting file input
      files: [],
      UserEmail: UserObj?.email,
      isModalOpenFeedback: false,
      rateData: 0,
      ticketId: '',
      ticketIdReturn: '',
      errorMessage: '',
      company_id: UserObj ? UserObj.company_id : null,
      pgno: 1,
      row: 25,
    };
    this.textareaRef = React.createRef();
  }
  openModal = (userEmail, ticketId) => {
    this.setState({ isModalOpen: true, userEmail, ticketId: ticketId });
  };
  openModalFeedback = () => {
    this.setState({ isModalOpenFeedback: true });
  };



  closeModal = () => {
    this.setState({ isModalOpen: false, userEmail: '' });
  };

  openModal1 = item => {
    this.setState({ isModalOpen1: true });
    this.setState({ ticketIdReturn: item });
  };

  // Add uploadDocument method
  uploadDocument1 = async file => {
    if (!file) return null;

    this.setState({ uploading: true });

    try {
      const sanitizedFileName = encodeURIComponent(file.name.trim());
      const attachments = {
        bucket: 'ticketing-uat',
        key: `attachment/${sanitizedFileName}`,
      };

      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
        attachments,
      );

      const uploadUrl = data?.uploadUrl;
      if (!uploadUrl) throw new Error('Failed to get upload URL.');

      await axios.put(uploadUrl, file, {
        headers: { 'Content-Type': file.type || 'binary/octet-stream' },
      });

      const trimmedUrl = uploadUrl.split('?')[0];
      const s3Key = trimmedUrl.split('amazonaws.com/')[1];

      this.setState({ uploading: false });
      return { s3Key, fileName: file.name }; // Return both S3 key and file name
    } catch (error) {
      console.error('Error uploading file:', error);
      this.setState({ uploading: false });
      return null;
    }
  };

  // Update handleFileChange to upload files to S3
  handleFileChange = async e => {
    const files = Array.from(e.target.files);
    const uploadedUrls = [];
    const uploadedNames = [];

    for (let file of files) {
      const result = await this.uploadDocument1(file);
      if (result) {
        uploadedUrls.push(result.s3Key);
        uploadedNames.push(result.fileName);
      }
    }

    this.setState(prev => ({
      commentFiles: [...(prev.commentFiles || []), ...uploadedUrls],
      commentFileNames: [...(prev.commentFileNames || []), ...uploadedNames],
      fileInputKey: Date.now(),
    }));
  };

  handleRemoveFileComment = idx => {
    this.setState(prev => ({
      commentFiles: (prev.commentFiles || []).filter((_, i) => i !== idx),
      commentFileNames: (prev.commentFileNames || []).filter(
        (_, i) => i !== idx,
      ),
      fileInputKey: Date.now(),
    }));
  };

  // Keep handleCommentToggle as is
  handleCommentToggle = () => {
    this.setState(prevState => ({
      showCommentSection: !prevState.showCommentSection,
    }));
  };

  // Keep handleCommentChange as is
  handleCommentChange = e => {
    this.setState({ commentMessage: e.target.value });
  };

  // Update handleCommentSubmit to ensure files are sent correctly
  handleCommentSubmit = async () => {
    const { commentMessage, commentFiles, ticketId } = this.state;

    if (!commentMessage) {
      console.error('Comment message is required');
      return;
    }

    try {
      if (this.state.uploading) {
        await new Promise(resolve => {
          const checkUpload = setInterval(() => {
            if (!this.state.uploading) {
              clearInterval(checkUpload);
              resolve();
            }
          }, 100);
        });
      }

      const cleanedFiles = (commentFiles || []).map(url => {
        const parts = url.split('/');
        return parts.slice(-2).join('/'); // Ensure format is attachment/filename
      });

      const requestBody = {
        ticketId: ticketId,
        message: commentMessage,
        commentFile: cleanedFiles.length > 0 ? cleanedFiles : [], // Ensure array is sent even if empty
      };

      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }tickets/v1/api/ticket/client/addcomment`,
        requestBody,
      );

      if (response.data.statusValue === 200) {
        toast.success(response.data.message);

        $('.close').click();

        // Reset fields
        this.setState({
          showCommentSection: false,
          commentMessage: '',
          commentFiles: [],
          commentFileNames: [],
          fileInputKey: Date.now(),
        });
      }
    } catch (error) {
      console.error(
        'Error submitting comment:',
        error.response?.data || error.message,
      );
    }
  };

  closeModal1 = () => {
    this.setState({ isModalOpen1: false });
  };

  handleChangeReturn = event => {
    this.setState({ returnedMessage: event.target.value });
  };

  // Handle File Upload

  uploadDocument = async file => {
    if (!file) return;

    this.setState({ fileName: file.name, uploading: true });

    try {
      // Step 1: Prepare attachment details
      const sanitizedFileName = encodeURIComponent(file.name.trim());
      const attachments = {
        bucket: 'ticketing-uat',
        key: `resources/${sanitizedFileName}`,
      };

      // Step 2: Request upload URL from API
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
        attachments,
      );

      const uploadUrl = data?.uploadUrl;
      if (!uploadUrl) throw new Error('Failed to get upload URL.');

      // Step 3: Upload file to S3 using pre-signed URL
      await axios.put(uploadUrl, file, {
        headers: { 'Content-Type': file.type || 'binary/octet-stream' },
      });

      // Step 4: Get the final file URL
      const trimmedUrl = uploadUrl.split('?')[0];

      // Step 5: Save the uploaded file URL in state
      this.setState({ returnFile: trimmedUrl, uploading: false });


    } catch (error) {
      console.error('Error uploading file:', error);
      this.setState({ uploading: false });
    }
  };

  // Handle File Change for Return Ticket
  handleFileChangeReturn = async e => {
    const files = Array.from(e.target.files);
    const uploadedUrls = [];
    const uploadedNames = [];

    for (let file of files) {
      this.setState({ uploading: true });

      try {
        const sanitizedFileName = encodeURIComponent(file.name.trim());
        const attachments = {
          bucket: 'ticketing-uat',
          key: `attachment/${sanitizedFileName}`,
        };

        const { data } = await axiosInstance.post(
          `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
          attachments,
        );

        const uploadUrl = data?.uploadUrl;
        await axios.put(uploadUrl, file, {
          headers: { 'Content-Type': file.type || 'binary/octet-stream' },
        });

        const trimmedUrl = uploadUrl.split('?')[0];
        const s3Key = trimmedUrl.split('amazonaws.com/')[1]; // 👈 Just this line added

        uploadedUrls.push(s3Key);
        uploadedNames.push(file.name);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }

    this.setState(prev => ({
      returnFiles: [...prev.returnFiles, ...uploadedUrls],
      returnFileNames: [...prev.returnFileNames, ...uploadedNames],
      uploading: false,
    }));
  };

  // Discard Uploaded File
  handleDiscard = () => {
    this.setState({ returnFile: null, fileName: null });
  };

  // Handle Return Ticket Submission
  handleSubmitReturn = async event => {
    event.preventDefault();
    this.setState({ isSubmitting: true });

    try {
      if (this.state.uploading) {
        await new Promise(resolve => {
          const checkUpload = setInterval(() => {
            if (!this.state.uploading) {
              clearInterval(checkUpload);
              resolve();
            }
          }, 100);
        });
      }

      const cleanedFiles = (this.state.returnFiles || []).map(url => {
        const parts = url.split('/');
        return parts.slice(-2).join('/');
      });

      const requestBody = {
        ticketId: this.state.ticketIdReturn,
        status: 'Returned',
        returnedMessage: this.state.returnedMessage,
        returnFile: cleanedFiles,
      };

      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }tickets/v1/api/ticket/client/return`,
        requestBody,
      );

      if (response.status === 200) {
        toast.success(response.data.message);
      }

      this.props.ticketListApi1();

      this.setState({ isModalOpen1: false }, () => {
        setTimeout(() => {
          this.setState({
            returnedMessage: '',
            returnFiles: [],
            returnFileNames: [],
            fileInputKey: Date.now(),
          });
        }, 300);
      });
    } catch (error) {
      console.error('Error returning ticket:', error);
      toast.error('Something went wrong while returning the ticket');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  openModalFeedback = () => {
    this.setState({ isModalOpenFeedback: true });
  };

  formatDueDate(dueDateString) {
    const dueDate = new Date(dueDateString);
    const now = new Date();
    const today = new Date(now.toDateString());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (dueDate.toDateString() === today.toDateString()) {
      // Due today
      return `Due by ${dueDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
    } else if (dueDate.toDateString() === tomorrow.toDateString()) {
      // Due tomorrow
      return 'Due by tomorrow';
    } else {
      // Due on some other day
      return `${dueDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
      })}`;
    }
  }

  closeModalFeedback = () => {
    this.setState({ isModalOpenFeedback: false, userEmail: '' });

    const { params } = this.props;

    // Make the API call
    this.props.TickList(params);
  };

  handleRating = ratingValue => {
    this.setState({
      rating: ratingValue,
      errorMessage: ratingValue === 0 ? 'Please provide a rating.' : '',
    });
  };

  handleRemoveFile = index => {
    const newFiles = [...this.state.returnFiles];
    const newNames = [...this.state.returnFileNames];
    newFiles.splice(index, 1);
    newNames.splice(index, 1);
    this.setState({ returnFiles: newFiles, returnFileNames: newNames });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();
    if (this.state.rating === 0) {
      this.setState({ errorMessage: 'Please provide a rating.' });
      return;
    }

    const { rating, feedback, files, UserEmail } = this.state;
    const formData = new FormData();
    formData.append('rating', rating);
    formData.append('feedback', feedback);
    formData.append('email', UserEmail);

    for (let i = 0; i < files?.length; i++) {
      formData.append('file', files[i].originFileObj);
    }

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/tickets/feedback/${this.state.ticketId}`,
        formData,
      );

      if (response.data.statusText == 'SUCCESS') {
        //   toast.success('Thank You for your feedback and rating', {
        //
        // });

        this.setState({ isModalOpenFeedback: true });
        this.setState({ isModalOpen: false });
        this.setState({ rating: 0 });
        this.setState({ feedback: '' });
        this.setState({
          files: [],
          errorMessage: '',
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  changeforward = () => {
    var itemIndex = this.state.TicktingAllList[this.state.setIndex + 1];
    var singleId = itemIndex;
    this.setState({
      setIndex: this.state.setIndex + 1,
      popupDetails: singleId,
      loader: true,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };

  changebackformward = () => {
    var itemIndex = this.state.TicktingAllList[this.state.setIndex - 1];
    var singleId = itemIndex;

    this.setState({
      setIndex: this.state.setIndex - 1,
      popupDetails: singleId,
      loader: true,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };
  sendId = async (items, i, items1) => {

    this.setState({ rateData: items.rating });
    this.setState({ sendMessage: items.Status });

    let uniqueId = items.ticketUniqueId;
    this.setState({ ticketId: uniqueId });

    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }tickets/v1/api/ticket/clientv2/${uniqueId}`,
      );

      if (response?.data?.statusValue === 200) {
        this.setState({ ticketDetailsView: response?.data?.data, setIndex: i });
      }
    } catch (e) {
      console.error(e);
    }
  };
  getMimeType = attachment => {
    if (attachment.endsWith('.pdf')) {
      return 'application/pdf';
    } else if (attachment.endsWith('.docx')) {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else {
      return 'image/jpeg'; // Default to an image type
    }
  };

  getMimeType1 = attachment => {
    const ext = attachment
      .split('.')
      .pop()
      .toLowerCase();
    if (ext === 'pdf') {
      return 'application/pdf';
    } else if (ext === 'docx') {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (['mp4', 'webm', 'ogg', 'mov'].includes(ext)) {
      return 'video';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(ext)) {
      return 'image';
    } else {
      return 'unknown'; // fallback for unsupported or unknown types
    }
  };

  openViewer = url => {
    window.open(url, '_blank');
  };
  openViewer1 = url => {
    window.open(url, '_blank');
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.ticketReducer !== prevProps.ticketReducer &&
      this.props.ticketReducer?.TicketAllList?.status === 200
    ) {
      const { list = [], total = 0, closed = 0, pending = 0 } =
        this.props.ticketReducer?.TicketAllList?.data || {};

      this.setState({
        TicktingAllList: list,
        totleSeatData: total,
        closedSeatData: closed,
        pendingSeatData: pending,
        isLoading: false, // Stop loading when data is set
      });
    }
  }

  render() {

    const {
      showCommentSection,
      commentFileNames,
      commentMessage,


      UserObj,
    } = this.state;
    const { ticketDetailsView } = this.state;
    const dueDateFormatted = ticketDetailsView?.dueDate
      ? this.formatDueDate(ticketDetailsView.dueDate)
      : '';



    const isUserAllowed =
      this.state.ticketDetailsView.userInfo?.email === this.state.UserEmail;

    const columns = [
      {
        title: "Request No.",
        noWrap: true,
        dataIndex: "requestId",
        key: "requestId",
        render: (_, record, index) => (
          <span
            className="SwLinkInfo HoverUnderline"
            role='button'
            onClick={() => {
              this.sendId(record, index, record.rating);
              this.setState({ showTicketDetails: true });
            }}
          >
            {record.requestId}
          </span>
        ),
      },
      { title: "Subcategory", dataIndex: "subCategory", key: "subCategory" },
      { title: "Subject", dataIndex: "Subject", key: "Subject" },
      { title: "Location", dataIndex: "Location", key: "Location" },
      { title: "Assignee", dataIndex: "ticketOwnerName", key: "ticketOwnerName" },
      {
        title: "Ticket Created",
        noWrap: true,
        dataIndex: "createdTime",
        key: "createdTime",
        render: (v) => moment(v).format("DD MMM YYYY"),
      },
      {
        title: "Ticket Closed",
        noWrap: true,
        dataIndex: "ticketCloseTime",
        key: "ticketCloseTime",
        render: (v) =>
          !v || v === "0000-00-00 00:00:00" || !moment(v).isValid()
            ? "--"
            : moment(v).format("DD MMM YYYY"),
      },
      { title: "Raised By", dataIndex: "contactName", key: "contactName" },
      {
        title: "Status",
        dataIndex: "Status",
        key: "Status",
        render: (v) =>
          v === "Closed" ? (
            <span className="SwTextSuccess">{v}</span>
          ) : (
            <span className="SwTextDanger SwTextSmall">{v}</span>
          ),
      },
      {
        title: "FeedBack",
        key: "rating",
        render: (_, record) =>
          record.rating === "" ? (
            "-"
          ) : record.rating === 0 ? (
            <a
              style={{ color: "#0B84E3", textDecoration: "underline" }}
              onClick={(e) => {
                e.stopPropagation();
                this.openModal(this.state.UserEmail, record.ticketUniqueId);
              }}
            >
              Rate
            </a>
          ) : (
            <div className="d-flex align-items-center">
              <span className="mr-1">{record.rating}</span>
              <img src="img/star.svg" alt="star" />
            </div>
          ),
      },
      {
        title: "Action",
        key: "action",
        render: (_, record, index) => (
          <div className="d-flex align-items-center gap-2">
            {record.Email === this.state.UserEmail &&
              record.Status === "Closed" ? (
              <img
                src="img/return-ticket.svg"
                width="14"
                style={{ cursor: "pointer" }}
                onClick={() => this.openModal1(record.ticketUniqueId)}
              />
            ) : (
              <span style={{ color: "#999" }}>–</span>
            )}

            <i
              className="fa fa-eye"
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.sendId(record, index, record.rating);
                this.setState({ showTicketDetails: true });
              }}
            />
          </div>
        ),
      },
    ];



    return (
      <>
        <SwOffCanvas
          show={this.state.showTicketDetails}
          onHide={() => this.setState({ showTicketDetails: false })}
          title="Ticket Details"
          footer={
            <>
              {this.state.rateData > 0 && (
                <div className="ml-auto ratedBtn">
                  <span>You rated</span>
                  <span>{this.state.rateData}</span>
                  <img src="img/star.svg" alt="star" />
                </div>
              )}

              {this.state.rateData == 0 && this.state.sendMessage === 'Closed' && isUserAllowed ? (
                <SwButton
                  size="sm"
                  onClick={() =>
                    this.openModal(
                      this.state.UserEmail,
                      this.state.ticketId,
                    )
                  }
                >
                  Share Feedback
                </SwButton>
              ) : (
                <div className="OffCanvasFooter_Btns">
                  {!isUserAllowed ? (
                    <SwTooltip
                      placement="top"
                      content={
                        <div>You can only send a message for tickets created by you.</div>
                      }
                    >
                      <span>
                        <SwButton
                          size="sm"
                          disabled
                          style={{ pointerEvents: 'none' }}
                        >
                          Send a message
                        </SwButton>
                      </span>
                    </SwTooltip>
                  ) : (
                    <SwButton
                      size="sm"
                      onClick={() => this.setState({ showCommentModal: true })}
                    >
                      Send a message
                    </SwButton>
                  )}
                </div>
              )}
            </>
          }
        >
          <div className="TicketModal">
            
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Ticket Id</p>
                    <p>{this.state?.ticketDetailsView?.ticketNumber}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Ticket Status</p>
                    <p>
                      {this.state?.ticketDetailsView?.clientStatus ==
                        'Closed' ? (
                        <div className="text-success">
                          {this.state?.ticketDetailsView?.clientStatus}
                        </div>
                      ) : (
                        <div className="text-danger">
                          {this.state.ticketDetailsView.clientStatus}
                        </div>
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Raised by</p>
                    <p>{this.state.ticketDetailsView?.userInfo?.name}</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Created time</p>
                    <p>
                      {this.state.ticketDetailsView.createdAt ===
                        '0000-00-00 00:00:00'
                        ? '--'
                        : moment
                          .utc(this.state.ticketDetailsView.createdAt)
                          .add(5, 'hours')
                          .add(30, 'minutes')
                          .format('DD MMM YYYY - h:mm:ss a')}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Category</p>
                    <p>{this.state.ticketDetailsView.category}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Sub Category</p>
                    <p>{this.state.ticketDetailsView.subCategory}</p>
                  </div>
                </div>
              </div>


              {[2021, 2073].includes(UserObj?.company_id) ? (
                <div className="row mb-3 hello">

                  <div className="col-md-6">
                    <div className="SwFormGroup">
                      <p className="SwTextGray mb-0">Due By </p>
                      <p>{dueDateFormatted}</p>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}



              <div className="row mb-3">
                <div className="col-md-12">
                  {this.state.ticketDetailsView.actionTimeline &&
                    this.state.ticketDetailsView.actionTimeline.map(
                      (item, index) => (
                        <div
                          className="TicketModalSection"
                          key={index}
                        >
                          {/* Avatar and Header Info */}
                          <div
                            className="TicketModal_AvatarSection"
                          >
                            <div
                              className="UserAvatar"
                              style={{ backgroundColor: item.background, }}
                            >
                              {item.nameInitials}
                            </div>
                            <div className='TicketUserInfo'>
                              {/* <strong>{item.fullName}</strong>{' '} */}
                              <div>{item.action}</div>
                              <div className='TicketUpdateTime'>
                                {new Date(item.createdAt).toLocaleString(
                                  'en-IN',
                                  {
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    second: 'numeric',
                                    hour12: true,
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                  },
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Description */}
                          {index === 0 && item.subject && (
                            <div className="TicketSubject">
                              {item.subject}
                            </div>
                          )}
                          <div className="TicketDescription">
                            <p>{item.description || '--'}</p>
                          </div>


                          {/* Attachments (updated like userAttachments) */}
                          {item.attachments &&
                            item.attachments.length > 0 ? (
                            <div className="mb-2">

                              <div className="d-flex flex-wrap">
                                {item.attachments.map((url, i) => (
                                  <div
                                    key={`timeline-attachment-${i}`}
                                    className="AttachedFileBox"
                                  >
                                    <div className="AttachedFileView">
                                      {this.getMimeType1(url) ===
                                        'application/pdf' ? (
                                        <img
                                          src="img/pdf-file-icon.svg"
                                          alt="Attachment"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      ) : this.getMimeType1(url) ===
                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                                        <iframe
                                          src={`https://docs.google.com/viewer?url=${url}&embedded=true`}
                                          title="DOCX Attachment"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      ) : this.getMimeType1(url) ===
                                        'video' ? (
                                        <img
                                          src={VideoIcon}
                                          className='FileIcon'
                                          alt="Video File"
                                          onClick={() => window.open(url, '_blank')}
                                        />
                                      ) : (
                                        <img
                                          src={url}
                                          alt="Attachment nn"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : ("")}
                        </div>
                      ),
                    )}
                </div>
              </div>

              <div className="row mb-3">
                {/* <div className="col-md-6">
                      <div className="TicketPopupRow">
                        <p className="SwTextGray mb-0">Created time</p>
                        <p>
                          {this.state.popupDetails.createdTime ===
                            '0000-00-00 00:00:00'
                            ? '--'
                            : moment.utc(
                              this.state.popupDetails.createdTime,
                            ).format('DD MMM YYYY - h:mm:ss a')}
                        </p>
                      </div>
                    </div> */}
                {/* <div className="col-md-12">
                      <div className="TicketPopupRow">
                        <p className="SwTextGray mb-0">Ticket closed time</p>
                        <p>
                          {this.state.ticketDetailsView.closedTime ===
                          '0000-00-00 00:00:00'
                            ? '--'
                            : moment
                                .utc(this.state.ticketDetailsView.closedTime)
                                .add(5, 'hours')
                                .add(30, 'minutes')
                                .format('DD MMM YYYY - h:mm:ss a')}
                        </p>
                      </div>
                    </div> */}
              </div>

              {/* <div className="row mb-3">
                    <div className="col-md-12">
                      <div className="TicketPopupRow">
                        <p className="SwTextGray mb-0">Resolution</p>

                        <p>
                          {this.state.ticketDetailsView.resolution
                            ? this.state.ticketDetailsView.resolution
                            : '--'}
                        </p>

                        <div className="d-flex flex-wrap">
                          {this.state?.ticketDetailsView
                            ?.resolutionAttachments &&
                          this.state?.ticketDetailsView?.resolutionAttachments
                            ?.length > 0 ? (
                            this.state?.ticketDetailsView?.resolutionAttachments?.map(
                              (attachment, index) => (
                                <div
                                  key={`resolution-attachment-${index}`}
                                  className="AttachedFileBox"
                                  style={{ margin: '5px' }}
                                >
                                  <div className="AttachedFileView">
                                    {this.getMimeType(attachment.url) ===
                                    'application/pdf' ? (
                                      <img
                                        src="img/pdf-file-icon.svg"
                                        alt="PDF Attachment"
                                        style={{
                                          width: '60px',
                                          height: '60px',
                                          objectFit: 'cover',
                                        }}
                                        onClick={() =>
                                          this.openViewer(attachment.url)
                                        }
                                      />
                                    ) : this.getMimeType(attachment.url) ===
                                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                                      <iframe
                                        src={`https://docs.google.com/viewer?url=${
                                          attachment.url
                                        }&embedded=true`}
                                        alt="DOCX Attachment"
                                        style={{
                                          width: '60px',
                                          height: '60px',
                                          objectFit: 'cover',
                                        }}
                                        onClick={() =>
                                          this.openViewer(attachment.url)
                                        }
                                      />
                                    ) : (
                                      <img
                                        src={attachment.url}
                                        alt="Attachment"
                                        style={{
                                          width: '60px',
                                          height: '60px',
                                          objectFit: 'cover',
                                        }}
                                        onClick={() =>
                                          this.openViewer(attachment.url)
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              ),
                            )
                          ) : (
                            <p>No attachments available.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}

              {/* <div className="row mb-3">

                   
                  </div> */}

              {/* <div className="row">
                      <div className="col-12">
                        <div className="pannelSet mtset">
                          Time Entries
                        </div>
                      </div>
                  </div>   
                          */}


            </div>
          


          <SwModal
            show={this.state.showCommentModal}
            onClose={() =>
              this.setState({
                showCommentModal: false,
                commentMessage: '',
                commentFileNames: '',
                files: [],
              })
            }
            title="Please enter your message"
            className="sw-default-modal"
            centered
            backdrop="static"
            keyboard={false}
            footer={
              <div className="d-flex justify-content-end align-items-center gap-3">
                <SwButton
                  variant="dark-outline"
                  size="sm"
                  onClick={() =>
                    this.setState({
                      showCommentModal: false,
                      commentMessage: '',
                      commentFileNames: '',
                      files: [],
                    })
                  }
                >
                  Cancel
                </SwButton>

                <SwButton
                  variant="dark"
                  size="sm"
                  onClick={() => {
                    this.handleCommentSubmit();
                    this.setState({
                      showCommentModal: false, files: [], commentMessage: '',
                      commentFileNames: '',
                    });
                  }}
                  disabled={this.state.uploading}
                >
                  Submit
                </SwButton>
              </div>
            }
          >
            {/* <SwButton variant="" className='btn-close btn-close-custom' onClick={this.closeModal} ></SwButton> */}
            <div className="SendMsgModal_content">
              <div className="SendMsg_row">
                <SwTextArea
                  ref={this.inputRef}
                  value={commentMessage}
                  onChange={this.handleCommentChange}
                  placeholder="Type your message here..."
                  rows={8}
                />
              </div>

              <div className="row mb-4">
                <div className="col-md-8">
                  <AntDUpload
                    type="button"
                    listType="text"
                    multiple
                    autoUpload={false}
                    fileList={this.state.files || []}
                    disabled={this.state.uploading}
                    onChange={({ fileList }) => {
                      this.setState({ files: fileList }, async () => {
                        for (let fileObj of fileList) {
                          if (!fileObj.uploaded) {
                            const result = await this.uploadDocument1(
                              fileObj.originFileObj
                            );

                            if (result) {
                              this.setState(prev => ({
                                commentFiles: [
                                  ...(prev.commentFiles || []),
                                  result.s3Key,
                                ],
                                commentFileNames: [
                                  ...(prev.commentFileNames || []),
                                  result.fileName,
                                ],
                              }));

                              fileObj.uploaded = true;
                            }
                          }
                        }
                      });
                    }}
                  >
                    <SwButton variant="primary" icon={<i className='bi bi-upload'></i>}>Upload Documents</SwButton>
                  </AntDUpload>
                </div>
              </div>
            </div>
          </SwModal>
        </SwOffCanvas>
        <SwOffCanvas
          show={this.state.isModalOpen1}
          onClose={() =>
            this.setState({
              isModalOpen1: false,
              returnFiles: [],
              returnFileNames: [],
              returnUploadList: [],
              returnedMessage: '',
            })
          }
          title="Return Ticket"
          placement="end"
          className="sw-default-offcanvas"
          footer={
            <div className="d-flex justify-content-end gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={this.resetValue}
              >
                Reset
              </SwButton>

              <SwButton
                size="sm"
                onClick={this.handleSubmitReturn}
                disabled={this.state.isSubmitting}
              >
                {this.state.isSubmitting ? (
                  <i className="fa fa-refresh fa-spin" />
                ) : (
                  "Submit"
                )}
              </SwButton>
            </div>
          }
        >
          <form onSubmit={this.handleSubmitReturn}>
            <div className="row">
              <div className="col-md-12 mt-3">
                <label className='SwFormLabel'>
                  Reason<span className="Required">*</span>
                </label>

                <SwTextArea
                  rows={4}
                  placeholder="Let us know why you want to return this ticket"
                  value={this.state.returnedMessage}
                  onChange={this.handleChangeReturn}
                  required
                />
              </div>

              <div className="row mb-4 mt-4">
                <div className="col-md-8">
                  <AntDUpload
                    type="button"
                    listType="picture"
                    multiple
                    autoUpload={false}
                    fileList={this.state.returnUploadList}
                    disabled={this.state.uploading}
                    onChange={({ fileList }) => {
                      this.setState({ returnUploadList: fileList }, async () => {
                        for (let fileObj of fileList) {
                          if (!fileObj.uploaded) {
                            this.setState({ uploading: true });

                            try {
                              const file = fileObj.originFileObj;
                              const sanitizedFileName = encodeURIComponent(file.name.trim());

                              const attachments = {
                                bucket: 'ticketing-uat',
                                key: `attachment/${sanitizedFileName}`,
                              };

                              const { data } = await axiosInstance.post(
                                `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
                                attachments
                              );

                              const uploadUrl = data?.uploadUrl;

                              await axios.put(uploadUrl, file, {
                                headers: { 'Content-Type': file.type || 'binary/octet-stream' },
                              });

                              const trimmedUrl = uploadUrl.split('?')[0];
                              const s3Key = trimmedUrl.split('amazonaws.com/')[1];

                              this.setState(prev => ({
                                returnFiles: [...prev.returnFiles, s3Key],
                                returnFileNames: [...prev.returnFileNames, file.name],
                              }));

                              fileObj.uploaded = true;
                            } catch (error) {
                              console.error("Error uploading file:", error);
                            } finally {
                              this.setState({ uploading: false });
                            }
                          }
                        }
                      });
                    }}
                  >
                    <SwButton variant="primary" icon={<i className='bi bi-upload'></i>}>
                      Upload Documents
                    </SwButton>
                  </AntDUpload>
                </div>
              </div>
            </div>
          </form>
        </SwOffCanvas>
        <div className='row'>
          <div className='col-12'>
            <SwKpiGroup>
              <SwKpi
                label='Total Ticket'
                value={this.state.totleSeatData}
              />
              <SwKpi
                label='Resolved'
                value={this.state.closedSeatData}
              />
              <SwKpi
                label='Pending'
                value={this.state.pendingSeatData}
              />
            </SwKpiGroup>
          </div>
        </div>
        <AntDTable
          columns={columns}
          dataSource={this.state.TicktingAllList}
          rowKey="ticketUniqueId"
          loading={this.state.isLoading}

          pagination={true}
          pageSize={this.props.row}
          currentPage={this.props.pgno}
          totalRecords={
            this.props.ticketReducer.TicketAllList.data?.rows
          }

          onPageChange={this.props.onPageChange}
        />
        <SwModal
          show={this.state.isModalOpen}
          onClose={this.closeModal}
          className="sw-small-modal ExpandedWidth"
          centered
          backdrop="static"
          keyboard={false}
        >
          <SwButton variant="" className='btn-close btn-close-custom' onClick={this.closeModal} ></SwButton>
          <div className='SwSubHeading Hv2 text-center'>
            <h2>Rate your recent support experience</h2>
          </div>
          <p className='lead text-center'>AMS | Unable to add new members...</p>
          <form onSubmit={this.handleSubmit}>
            <div className="SwRating">
              <RcRate
                className="SwRating_lg mb-2"
                count={5}
                value={this.state.rating}
                allowHalf={false}
                onChange={(value) => this.handleRating(value)}
              />
            </div>

            {this.state.errorMessage && (
              <p className="text-danger">{this.state.errorMessage}</p>
            )}
            <SwTextArea
              rows={5}
              name="feedback"
              placeholder="Write something here..."
              value={this.state.feedback}
              onChange={this.handleChange}
            />
            <div className="add-files mt-3">

              <AntDUpload
                type="button"
                listType="text"
                multiple
                autoUpload={false}
                fileList={this.state.files}
                onChange={({ fileList }) => {
                  this.setState({ files: fileList });
                }}
              >
                <SwButton variant="primary" icon={<i className='bi bi-upload'></i>}>
                  Upload Documents
                </SwButton>
              </AntDUpload>
            </div>
            <div className="FeedbackSubmit mt-3">
              <SwButton type='submit' >
                Submit
              </SwButton>
            </div>
          </form>
        </SwModal>
        <SwModal
          show={this.state.isModalOpenFeedback}
          onClose={this.closeModalFeedback}
          className="sw-small-modal ExpandedWidth"
          centered
          backdrop="static"
          keyboard={false}
        >
          <div className="thank-you text-center">
            <SwButton variant="" className='btn-close btn-close-custom' onClick={this.closeModalFeedback} ></SwButton>
            <div className="thank-you-icon mb-3">
              <img src="./img/FeedbackThankyou-icon.svg" alt="Thank You" />
            </div>
            <div className='SwSubHeading Hv2'>
              <h3>Thank You For Your Feedback</h3>
            </div>
            <SwButton onClick={this.closeModalFeedback}>
              Done
            </SwButton>
          </div>
        </SwModal>
        <Toaster position="top-right" reverseOrder={false} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ticketReducer: state.ticketReducer,
  visitorReducer: state.visitorReducer,
});

const mapActionsToProps = {
  TickList,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(TicktingTable);
